var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 15.3337V19.467C29.3334 22.4539 29.3334 23.9474 28.7521 25.0883C28.2408 26.0918 27.4249 26.9077 26.4214 27.419C25.2805 28.0003 23.787 28.0003 20.8001 28.0003H11.2001C8.21313 28.0003 6.71966 28.0003 5.5788 27.419C4.57527 26.9077 3.75937 26.0918 3.24805 25.0883C2.66675 23.9474 2.66675 22.4539 2.66675 19.467V12.5337C2.66675 9.54671 2.66675 8.05324 3.24805 6.91238C3.75937 5.90885 4.57527 5.09295 5.5788 4.58162C6.71966 4.00033 8.21313 4.00033 11.2001 4.00033H16.6667M25.3334 10.667V2.66699M21.3334 6.66699H29.3334M21.3334 16.0003C21.3334 18.9458 18.9456 21.3337 16.0001 21.3337C13.0546 21.3337 10.6667 18.9458 10.6667 16.0003C10.6667 13.0548 13.0546 10.667 16.0001 10.667C18.9456 10.667 21.3334 13.0548 21.3334 16.0003Z",
    stroke: "#2C2C2C",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.dd87a5c8f9c9a353cc2044d31dfbd18f.svg";
export { ForwardRef as ReactComponent };